// constants.js
const ON_CHANGE_DEBOUNCE_TIMER = 300;
const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// pubsub.js
let subscribers = {};
function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }
  subscribers[eventName] = [...subscribers[eventName], callback];
  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}
function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

// custom.js
(function () {
  const selectors = {
    productImageSwiper: ".productImageSwiper",
  };

  const productImageSwipers = document.querySelectorAll(
    selectors.productImageSwiper
  );

  if (productImageSwipers.length == 0) return;

  productImageSwipers.forEach((productImageSwiper) => {
    const swiperId = productImageSwiper.getAttribute("data-id");
    new Swiper(`${selectors.productImageSwiper}[data-id="${swiperId}"]`, {
      spaceBetween: 20,
      pagination: {
        el: `.swiper-pagination[data-id="${swiperId}"]`,
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1.5,
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 40,
        },
      },
    });
  });
})();

(function () {
  const selectors = {
    featuredCollectionSwiper: ".featured-collection-swiper",
  };

  const featuredCollectionSwipers = document.querySelectorAll(
    selectors.featuredCollectionSwiper
  );

  if (featuredCollectionSwipers.length == 0) return;

  featuredCollectionSwipers.forEach((featuredCollectionSwiper) => {
    const swiperId = featuredCollectionSwiper.getAttribute("data-id");
    const swiperOptions = JSON.parse(
      featuredCollectionSwiper.dataset.swiperOptions.replaceAll("\n", "")
    );

    console.log(swiperOptions);
    new Swiper(
      `${selectors.featuredCollectionSwiper}[data-id="${swiperId}"]`,
      swiperOptions
    );
  });
})();

(function () {
  const selectors = {
    featuredBlogSwiper: ".featured-blog-swiper",
  };

  const featuredBlogSwipers = document.querySelectorAll(
    selectors.featuredBlogSwiper
  );

  if (featuredBlogSwipers.length == 0) return;

  featuredBlogSwipers.forEach((featuredBlogSwiper) => {
    const swiperId = featuredBlogSwiper.getAttribute("data-id");
    const swiperOptions = JSON.parse(
      featuredBlogSwiper.dataset.swiperOptions.replaceAll("\n", "")
    );

    console.log(swiperOptions);
    new Swiper(
      `${selectors.featuredBlogSwiper}[data-id="${swiperId}"]`,
      swiperOptions
    );
  });
})();

// tabs.js
class Tabs extends HTMLElement {
  constructor() {
    super();

    this.tabHeaders = this.querySelectorAll("tab-header");
    this.tabDetails = this.querySelectorAll("tab-details");

    this.tabHeaders.forEach((header) => {
      header.addEventListener("click", this.onHeaderClick.bind(this));
    });
  }

  onHeaderClick(event) {
    const header = event.target;
    const tab = header.closest("tab-header");
    const tabDetails = this.querySelector(
      `#Detail-${tab.getAttribute("aria-controls")}`
    );

    this.tabHeaders.forEach((header) => {
      header.removeAttribute("aria-selected");
      header.setAttribute("tabindex", -1);
    });

    this.tabDetails.forEach((details) => {
      details.setAttribute("aria-hidden", true);
    });

    tab.setAttribute("aria-selected", true);
    tab.setAttribute("tabindex", 0);
    tabDetails.removeAttribute("aria-hidden");
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}
customElements.define("custom-tabs", Tabs);
